import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';
import LMS_ICON from '../Images/lms_icon.png';
import FEES_ICON from '../Images/fees1.png';
import TRANSPORT_ICON from '../Images/transport2.png';
import LIB_ICON from '../Images/library.png';
import STORE_ICON from '../Images/store.png';
import NOTIFY_ICON from '../Images/notification.png';
import ETL_ICON from '../Images/etl.png';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LegendCard from '../Components/LegendCard/index';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 220,
    '&:hover': {
      cursor: 'pointer',
    },
  },

  outerWrap: {
    height: '100%',
    alignItems: 'center',
  },
  title: {
    fontSize: 20,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  description: {
    fontSize: 14,
  },
  adminPanel: {
    fontSize: 32,
    fontWeight: 'bold',
    textAlign: 'center',
    width: '100%',
  },
  insideContain: {
    margin: '0 auto',
  },
}));

function Home() {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();

  const array = [
    // {
    //   title: t('headings:lms'),
    //   imgUrl: LMS_ICON,
    //   description: t('messages:lms_Description'),
    //   redirectUrl: 'https://vkgi-lms.ken42.com/',
    // },
    // {
    //   title: t('headings:fee_Payment'),
    //   description: t('messages:feePayment_Description'),
    //   imgUrl: FEES_ICON,
    //   redirectUrl: 'https://uat.feecollection.zenqore.com/#/vkgi/',
    // },
    // {
    //   title: t('headings:transport_Admin'),
    //   description: t('messages:transport_Description'),
    //   imgUrl: TRANSPORT_ICON,
    //   redirectUrl: '',
    // },
    // {
    //   title: t('headings:library_Admin'),
    //   description: t('messages:library_Description'),
    //   imgUrl: LIB_ICON,
    //   redirectUrl: '',
    // },
    // {
    //   title: t('headings:eCommerce_Admin'),
    //   description: t('messages:eCommerce_Description'),
    //   imgUrl: STORE_ICON,
    //   redirectUrl: 'https://www.storehippo.com/admin',
    // },
    {
      title: t('headings:notifications'),
      description: t('messages:notifications_Description'),
      imgUrl: NOTIFY_ICON,
      redirectUrl: '/app/notification',
    },
    // {
    //   title: t('headings:etl'),
    //   description: t('messages:etl_Description'),
    //   imgUrl: ETL_ICON,
    //   redirectUrl: `/app/etl`,
    // },
  ];

  return (
    <div className={classes.outerWrap}>
      <Grid container className={classes.insideContain} spacing={1}>
        {array.map((item, index) => {
          return (
            <Grid
              item
              md={4}
              sm={4}
              xs={12}
              key={index}
              style={{ padding: 4 }}
              onClick={() => {
                if (item.title === 'Notifications') {
                  history.push(`${item.redirectUrl}`);
                } else if (item.title === 'ETL') {
                  history.push(`${item.redirectUrl}`);
                } else {
                  window.open(item.redirectUrl);
                }
              }}
            >
              <Card className={classes.root}>
                <CardContent>
                  <Typography style={{ textAlign: 'center' }}>
                    <img
                      src={item.imgUrl}
                      alt="logo"
                      style={{
                        width: '60px',
                        borderRadius: '50%',
                        height: '60px',
                      }}
                    ></img>
                  </Typography>
                  <Typography
                    className={classes.title}
                    color="textSecondary"
                    gutterBottom
                  >
                    {item.title}
                  </Typography>
                  <Typography className={classes.description}>
                    {item.description}
                  </Typography>
                  {/* <Typography>{item.redirectUrl}</Typography> */}
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
}

export default Home;
